<template>
  <div v-loading="loading">
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefContractList' }">
          待提交合同
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info ref="baseinfo" :form="info" :order-sales="orderSales" :is-overdue-customer="isOverdueCustomer" />
    <rejected-list ref="rejectedList" v-loading="rejectedLoading" />
    <product
      v-if="info.id"
      ref="productList"
      :more-address="moreAddress"
      :multiaddress="info.multiaddress"
      :multiaddress-value="info.multiaddressValue"
      :is-compute-price="isShowFreightInfo"
      :contract-type="info.contractType"
      :department-code="info.departmentCode"
      :product-list="productList"
      :info-all="info"
      :contract-id="info.id"
      :freight="freight"
      :rebate-amount="info.rebateAmount"
      :rebate="info.rebate"
      :sales-type="info.salesType"
      :as-inter-direct="info.asInterDirect"
      :is-pilot="isEbgDeliveryPilot"
      @chooseAddress="chooseAddress"
      @changeAddress="changeAddress"
      @finalNet="finalNetSale"
      @orderSale="orderSale"
      @changeMoreAddress="changeMoreAddress"
      @freightChange="freightChange"
      @reChange="reChange"
      @getFreight="getFreight"
    >
      <template slot="freightInfo" slot-scope="{ setProductInnerInfo }">
        <freight-info
          v-show="!hasContractType"
          ref="freightInfo"
          :form="info"
          :product-list="productList"
          :contract-num="info.contractNum"
          :receipt-address-id="info.receiptAddressId || ''"
          :more-address="moreAddress"
          @hook:mounted="setProductInnerInfo($refs.freightInfo)"
          @hook:beforeDestroy="setProductInnerInfo(null)"
          @reChange="reChange"
          @getFreight="getFreight"
          @invalidateMoreAddressFee="invalidateMoreAddressFee"
        />
      </template>
      <div style=" position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 10000;
        background: rgba(64,158,255,0.1);"
      >
        <el-button type="primary" :loading="submitLoading" @click="submit">
          保存并前往盖章
        </el-button>
      </div>
    </product>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import product from './product';
import freightInfo from './freightInfo';
import { getContractDetailAllInfoByConNum, saveContractInfo, getRejectedList, checkCloudDesktopAuthorization, addNoticeSendMail, queryIsMoreAddress, isEbgDeliveryPilotArea } from '@/API';
import rejectedList from '../../../orderPersion/handler/rejectedList';
import { calculateProductSettlementAmount } from '@/API/index.js';
import { isAgentOverdue } from '@/API/agentOverdue';
import { getNum } from '@/libs/util';
import Big from 'big.js';
import dayjs from 'dayjs';
import { mapActions } from 'vuex';

export default {
  data () {
    return {
      info: {
        bankInfos: []
      },
      adressId: '',
      productList: [],
      loading: false,
      submitLoading: false,
      finalNetSales: 0,
      freight: 0,
      orderSales: 0,
      rejectedLoading: false,
      noShow: false,
      moreAddress: false,
      moreAddressFeeFlag: false,
      isOverdueCustomer: false,
      // AI修改：记录多地址运费差价上次成功计算时的条件快照。
      moreAddressFeeCalcKey: '',
      isEbgDeliveryPilot: false
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    baseInfo,
    product,
    freightInfo,
    rejectedList
  },
  computed: {
    // 判断是否是其他系统过来的单子，如果是，则不计算运费和显示
    isShowFreightInfo () {
      if (this.info.contractType === 'SMB分销下单') {
        return false;
      }
      return true;
    },
    hasContractType () {
      return this.info.contractType === '服务订单';
    }
  },
  methods: {
    ...mapActions([
      'getuser'
    ]),
    async checkAgentOverdue () {
      this.isOverdueCustomer = false;
      const { distributorName, integratorName } = this.info;
      if (!distributorName || !integratorName) {
        return;
      }
      try {
        const user = await this.getuser();
        if (Number(user.isDistributors) !== 1) {
          return;
        }
        const res = await isAgentOverdue(distributorName, integratorName);
        const json = res.data;
        this.isOverdueCustomer = json.status === '200' && json.data === true;
      } catch (error) {}
    },
    isMoreAddress (params) {
      queryIsMoreAddress(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.moreAddress = data;
        }
      });
    },
    changeMoreAddress (val) {
      this.moreAddress = val;
      // AI修改：多地址状态切换后，旧的运费差价计算结果立即失效。
      this.moreAddressFeeFlag = false;
      this.moreAddressFeeCalcKey = '';
    },
    // AI修改：运输方式、承运商或货运重置后，显式清空多地址差价计算状态。
    invalidateMoreAddressFee () {
      this.moreAddressFeeFlag = false;
      this.moreAddressFeeCalcKey = '';
    },
    freightChange (val, flagFee) {
      this.getFreight(val);
      this.moreAddressFeeFlag = flagFee;
      // AI修改：只有成功计算后的当前条件，才允许作为可提交的多地址差价结果。
      this.moreAddressFeeCalcKey = flagFee ? this.getMoreAddressFeeCalcKey() : '';
    },
    // AI修改：获取当前页面真实使用的货运条件，多地址计算和提交校验共用它。
    getCurrentFreightInfo () {
      if (this.$refs.freightInfo && this.$refs.freightInfo.info) {
        return this.$refs.freightInfo.info;
      }
      return {
        shippingType: this.info.shippingType,
        carrier: this.info.carrier
      };
    },
    // AI修改：生成多地址运费差价的条件快照，条件变化后必须重新计算。
    getMoreAddressFeeCalcKey () {
      const freightInfo = this.getCurrentFreightInfo();
      return JSON.stringify({
        shippingType: freightInfo.shippingType !== undefined ? freightInfo.shippingType : 0,
        carrier: freightInfo.carrier || '默认物流',
        receiptAddressId: this.info.receiptAddressId || '',
        contractProductInfos: this.productList
          .filter(row => row.productName !== '价外费用-运费')
          .map(row => ({
            id: row.id || '',
            idBak: row.idBak || '',
            productCode: row.productCode || '',
            productCategoryName: row.productCategoryName || '',
            productNum: this.getProServeNum(row),
            addressId: row.addressId || '',
            contactName: row.contactName || '',
            receiverProvince: row.receiverProvince || '',
            receiverCity: row.receiverCity || '',
            receiverDistrict: row.receiverDistrict || '',
            detailedAddress: row.detailedAddress || '',
            contactPhone: row.contactPhone || ''
          }))
      });
    },
    async initEbgDeliveryPilot (info) {
      this.isEbgDeliveryPilot = false;
      const departmentCode = info && info.departmentCode;
      if (!departmentCode || !departmentCode.startsWith('000062')) {
        return;
      }
      try {
        const createTime = info.createTime;
        const createDate = createTime ? dayjs(createTime).format('YYYY-MM-DD') : undefined;
        const pilotRes = await isEbgDeliveryPilotArea(departmentCode, createDate);
        const pilotJson = pilotRes.data || {};
        if (pilotJson.status !== '200' || pilotJson.data !== true) {
          return;
        }
        this.isEbgDeliveryPilot = true;
      } catch (e) {
        // 试点接口异常时维持原客期逻辑，不能阻断合同提交。
        this.isEbgDeliveryPilot = false;
      }
    },
    // 获取服务订单数量
    getProServeNum (row) {
      return this.info.contractType === '服务订单' ? row.serviceLife : row.productNum;
    },
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum, true).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.info = json.data;
          this.initEbgDeliveryPilot(this.info);
          this.checkAgentOverdue();
          if (this.info.contractType !== '国际业务下单' && this.info.contractType !== '国际分销下单') {
            this.isMoreAddress(this.info);
          }
          json.data.bankInfos.forEach((item) => {
            if (item.isDefault) {
              this.info.paymentBankId = item.openBankId;
            }
          });
          let authorizationEmail = '';
          authorizationEmail = json.data.contractProductInfos[0].authorizationEmail ? json.data.contractProductInfos[0].authorizationEmail : '';
          this.$set(this.info, 'authorizationEmail', authorizationEmail);

          let params = json.data.contractProductInfos.map(row => {
            return {
              productPriceSingle: row.productPriceSigle,
              productNum: this.getProServeNum(row),
              id: row.id,
              productCode: row.productCode,
              productCategoryName: row.productCategoryName
            };
          });
          this.setFreightMoney(params).then(res => {
            json.data.contractProductInfos.forEach((row, index) => {
              let result = res[index];
              row.orderAmount = result.orderAmount;
              row.settlementAmount = result.settlementAmount;
            });

            this.productList = json.data.contractProductInfos;
            this.productList.forEach((item) => {
              item.productNumBak = item.productNum;
            });

            this.$nextTick(() => {
              this.initRejected(json.data.id);
              if (json.data.length > 10) {
                this.$refs.productList.tableHeight = 500;
              } else {
                this.$refs.productList.tableHeight = '';
              }
              this.$refs.baseinfo.getEditRebateUsedList();
            });
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    async submit () {
      if (this.submitLoading) return;
      this.submitLoading = true;
      try {
        await this.submitValidated();
      } catch (error) {
        this.$message.error('提交失败，请重试');
      } finally {
        this.submitLoading = false;
      }
    },
    async submitValidated () {
      if (this.moreAddress && this.info.contractType !== '国际业务下单' && this.info.contractType !== '国际分销下单') {
        // AI修改：提交前校验当前条件是否仍然等于上次成功计算多地址差价时的条件。
        const moreAddressFeeCalcKey = this.getMoreAddressFeeCalcKey();
        if (!this.moreAddressFeeFlag || !this.moreAddressFeeCalcKey || moreAddressFeeCalcKey !== this.moreAddressFeeCalcKey) {
          this.moreAddressFeeFlag = false;
          this.moreAddressFeeCalcKey = '';
          this.$message.error('请先计算运费差价');
          return;
        }
      }
      let addressMultia = {
        multiaddress: ''
      };
      let productListRef = this.$refs.productList;
      if (this.$refs.productList.formData.multiaddress === '其他') {
        if (!this.$refs.productList.multiaddressValue) {
          this.$message.error('请输入特殊发货需求');
          return;
        }
        addressMultia.multiaddress = '特殊发货需求--' + this.$refs.productList.multiaddressValue;
      } else {
        addressMultia.multiaddress = this.$refs.productList.formData.multiaddress;
      }

      let info = await this.$refs.baseinfo.validate();
      console.log(info);

      let rebateList = this.$refs.baseinfo.dialogNode.rebateUsedList;
      if (!info) {
        return;
      }
      let product = await this.$refs.productList.validate();
      if (!product) return;

      let freightInfo = {};
      // 判断是否是其他系统过来的单子，如果是，则不计算运费和显示
      if (this.hasContractType) {
        freightInfo = {
          shippingType: 0,
          carrier: '默认物流',
          freight: 0,
          freightPayType: 0
        };
      } else if (this.isShowFreightInfo) {
        freightInfo = await this.$refs.freightInfo.validate();
        if (!freightInfo) return;
      }

      let flag = false;
      let productCodeArrayStr = '';
      product.forEach((item) => {
        if (item.productCode) {
          productCodeArrayStr += item.productCode + ',';
        }
      });
      if (this.info.contractType !== '服务订单' && this.info.contractType !== '国际分销下单' && this.info.contractType !== '国际业务下单') {
        const _check = [];
        for (let i = 0; i < product.length; i++) {
          let item = product[i];
          if ((item.productNumBak || item.productNumBak === 0) && item.id) {
            let total = 0;
            product.forEach((one) => {
              if (one.idBak === item.id || one.id === item.id) {
                total += one.productNum;
              }
            });

            if (total !== item.productNumBak) {
              // this.$message.error(`${item.productName}拆行后的数量总和要等于拆行前的数量，请修改后再提交`);
              // return;
              _check.push(item.productName);
            }
          }
        }
        if (_check.length) {
          this.$message.error(`${_check.join('、')}拆行后的数量总和要等于拆行前的数量，请修改后再提交`);
          return;
        }
      }

      if (info.specialProduct === 2 && !this.productList.length) {
        return this.submitFormData(info, product, rebateList, addressMultia, productListRef, freightInfo);
      } else {
        const getSubmissionState = () => JSON.stringify({
          info,
          product,
          rebateList,
          freightInfo: this.$refs.freightInfo ? this.$refs.freightInfo.info : freightInfo,
          formData: productListRef.formData,
          multiaddressValue: productListRef.multiaddressValue,
          adressId: this.adressId,
          moreAddress: this.moreAddress,
          moreAddressFeeFlag: this.moreAddressFeeFlag,
          moreAddressFeeCalcKey: this.moreAddressFeeCalcKey,
          orderSales: this.orderSales,
          finalNetSales: this.finalNetSales
        });
        const submissionState = getSubmissionState();
        return checkCloudDesktopAuthorization(productCodeArrayStr).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (productListRef.amountPending > 0 || submissionState !== getSubmissionState()) {
              this.$message.error('提交期间数据发生变化，请等待金额计算完成后重新提交');
              return;
            }
            flag = json.data;
            if (flag && !this.info.authorizationEmail) {
              this.$message.warning('请输入云桌面授权邮箱');
            } else {
              return this.submitFormData(info, product, rebateList, addressMultia, productListRef, freightInfo);
            }
          } else {
            this.$message.error(json.err || '云桌面授权检查失败，请重试');
          }
        });
      }
    },

    // 提交
    submitFormData (info, product, rebateList, addressMultia, productListRef, freightInfo) {
      if (!this.adressId && this.info.contractType !== '国际业务下单' && this.info.contractType !== '国际分销下单') {
        if (this.moreAddress && product[0].addressId) {
          this.adressId = product[0].addressId;
        } else {
          this.$message.warning('收货地址有问题，请在货运信息的【配送至】栏选择或更改收货地址后再提交');
          return;
        }
      }
      let contractProductInfos = [];
      if (this.info.contractType !== '国际业务下单' && this.info.contractType !== '国际分销下单') {
        contractProductInfos = product;
        contractProductInfos.forEach((item) => {
          item.authorizationEmail = info.authorizationEmail;
        });
        // product.forEach((item) => {
        //   contractProductInfos.push({
        //     id: item.id,
        //     settlementAmount: item.settlementAmount,
        //     expectedDeliveryDate: item.expectedDeliveryDate,
        //     selfMention: item.selfMention,
        //     rate: item.rate, // 税率
        //     authorizationEmail: info.authorizationEmail,
        //     addressId: item.addressId,
        //     contactName: item.contactName,
        //     receiverProvince: item.receiverProvince,
        //     receiverCity: item.receiverCity,
        //     receiverDistrict: item.receiverDistrict,
        //     detailedAddress: item.detailedAddress,
        //     contactPhone: item.contactPhone
        //   });
        // });
      } else {
        product.forEach((item) => {
          contractProductInfos.push({
            id: item.id,
            settlementAmount: item.settlementAmount,
            expectedDeliveryDate: item.expectedDeliveryDate,
            selfMention: item.selfMention,
            rate: item.rate, // 税率
            authorizationEmail: info.authorizationEmail
          });
        });
      }
      let rebateListVo = [];
      rebateList.forEach((item) => {
        rebateListVo.push({
          rebateNum: item.rebateNumber,
          rebateAmount: item.useAmount,
          rebateTypeName: item.strRebateType
        });
      });
      let param = {
        contractProductInfos,
        id: info.id,
        invoiceEmail: info.invoiceEmail, // 发票邮箱地址
        isOrderAdminCreate: false,
        contractNum: info.contractNum,
        contractDetailId: info.contractDetailId,
        customerContractNum: info.customerContractNum,
        orderUnitPhone: info.orderUnitPhone,
        salesType: info.salesType,
        shipType: info.shipType,
        isRebate: info.isRebate,
        rebateAmount: info.rebateAmount,
        paymentBankId: info.paymentBankId,
        additionalTerms: info.additionalTerms,
        remarks: info.remarks,
        deliverRemark: info.deliverRemark,
        invoiceRemark: info.invoiceRemark,
        receiptAddressId: this.adressId,
        actualSettlementAmount: this.finalNetSales,
        orderSales: this.orderSales,
        setNoticeMail: info.setNoticeMail,
        useRebateVO: {
          contractNum: info.contractNum,
          orderAmount: info.orderSales,
          projectName: info.projectName,
          rebateListVo
        },
        multipleAddressesFlag: this.moreAddress,
        // shppingType: '1', // 运输方式
        // carrier: '顺丰', // 承运商
        // freight: '500.00', // 运费
        // freightPayType: '1', // 运费支付方式0现金，1返利
        ...freightInfo,
        ...addressMultia,
        // 特殊开票需求
        specialTicketRequirements: productListRef.formData.specialTicketRequirements === '其他特殊需求' ? productListRef.formData.otherTxet : productListRef.formData.specialTicketRequirements
      };
      addNoticeSendMail(info.setNoticeMail).then((res) => {
        let json = res.data;
        if (json.status === '200') {
        }
      }).catch((err) => {
        console.log(err);
      });
      return saveContractInfo(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data !== 'true') {
            this.$notify({
              title: json.data,
              type: 'success'
            });
            return;
          }
          this.$notify({
            title: '提交成功',
            type: 'success'
          });

          // 特殊删除时战略合同 && 产品行金额0
          let money = product.reduce((pre, cur) => getNum(Big(getNum(cur.orderAmount)).plus(pre).toString()), 0);
          if (info.specialProduct === 2 && money === 0) {
            this.$router.back();
          } else {
            this.$router.replace({
              name: 'doSeal',
              params: {
                contractNum: info.id
              }
            });
          }
        } else {
          this.$message.error(json.err || '提交失败，请重试');
        }
      });
    },

    finalNetSale (val) {
      this.finalNetSales = val;
    },
    orderSale (val) {
      this.orderSales = val;
    },
    initRejected (contractId) {
      this.rejectedLoading = true;
      getRejectedList(contractId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.rejectedList.rejectedList = json.data;
          this.rejectedLoading = false;
        }
      }).catch((res) => {
        this.rejectedLoading = false;
      });
    },
    // 监听子组件freightInfo运费支付方式改变触发事件
    // data.product 运费信息
    // data.flag 1表示添加 0表示删除
    reChange (data) {
      // 查询运费行，获取下标
      let index = this.productList.findIndex(function (v) {
        return v.productName === '价外费用-运费';
      });

      if (data.flag === 1) {
        // 判断产品列表里面是否有运费，如果有则不添加
        if (index === -1) {
          let params = [
            ...this.productList.map(row => {
              return {
                productPriceSingle: row.productPriceSigle,
                productNum: this.getProServeNum(row),
                id: row.id,
                productCode: row.productCode,
                productCategoryName: row.productCategoryName
              };
            }),
            { productPriceSingle: data.product.productPriceSigle, productNum: 1 }
          ];

          this.setFreightMoney(params).then((res) => {
            // 添加运费行
            this.productList.push({ ...data.product, rate: '13%', orderAmount: 0, settlementAmount: 0 });
            // 设置金额
            this.productList.forEach((row, index) => {
              let result = res[index];
              row.orderAmount = result.orderAmount;
              row.settlementAmount = result.settlementAmount;
            });
          });
        } else {
          this.productList.forEach((row) => {
            if (row.productName === '价外费用-运费') {
              row.productPriceSigle = row.beforeSplitProductPriceSigle = row.orderAmount = row.settlementAmount = data.product.productPriceSigle;
            }
          });
        }
      } else {
        if (index !== -1) {
          // 删除运费行
          this.productList.splice(index, 1);
          let params = this.productList
            .map(row => {
              return {
                productPriceSingle: row.productPriceSigle,
                productNum: this.getProServeNum(row),
                id: row.id,
                productCode: row.productCode,
                productCategoryName: row.productCategoryName
              };
            })
            .slice(0, this.productList.length - 1);

          this.setFreightMoney(params).then((res) => {
            // 删除运费行
            // this.productList.splice(index, 1);
            // 设置金额
            this.productList.forEach((row, index) => {
              let result = res[index];
              row.orderAmount = result.orderAmount;
              row.settlementAmount = result.settlementAmount;
            });
          });
        }
      }
    },
    // 初始化地址和切换地址成功触发
    chooseAddress (val) {
      this.adressId = val.id;
      this.info.receiptAddressId = val.id;
    },
    // 切换地址成功
    changeAddress () {
      // 判断是否是其他系统过来的单子，如果是，则不计算运费和显示
      if (this.isShowFreightInfo && !this.hasContractType) {
        // 重置运费信息
        this.$refs.freightInfo.reset();
      }
    },
    // 监听子组件运费模块中获取运费事件，并把值传给子组件产品列表
    getFreight (data) {
      if (this.info.contractType !== '国际业务下单' && this.info.contractType !== '国际分销下单') {
        this.freight = this.info.freight = data;
      } else {
        this.freight = data;
      }
    },

    /**
     * @desc 产品初始化 或 生成运费 调用接口计算获取：订单金额和实际结算金额
     * @param {array} productList 集合 { productPriceSingle, productNum, id, productCode, productCategoryName }
    */
    setFreightMoney (productList) {
      let params = {
        // 合同返点
        rebate: this.info.rebate,
        // 返利金额
        rebateAmount: this.info.rebateAmount,
        // 通讯折扣
        communicationOrderDiscount: 0,
        // 1 现销 2 赊销
        salesType: this.info.salesType,
        productList
      };

      return new Promise((resolve, reject) => {
        calculateProductSettlementAmount(params)
          .then(res => {
            let { status, data } = res.data;
            if (status === '200') {
              resolve(data);
            }
          }).catch((err) => reject(err));
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="scss"></style>
